export default {
  profile: [],
  total_notification: 0
}



// WEBPACK FOOTER //
// ./src/store/module/profile/state.js